import type { Contact } from '../../domain/contact';
import type { CollectedEmail } from '../../domain/meeting';
import type { CollectedDataItem } from '../../domain/message';

const validateString = (value: unknown) => typeof value === 'string' && value.trim() !== '';
const validateArray = (value: unknown) => Array.isArray(value) && value.length > 0;

export const linkedinContactValidators = [
  {
    name: 'Full Name',
    validator: (data: unknown) =>
      validateString((data as CollectedDataItem[]).find((item) => item.name === 'Full Name')?.content),
  },
  {
    name: 'Title',
    validator: (data: unknown) =>
      validateString((data as CollectedDataItem[]).find((item) => item.name === 'Title')?.content),
  },
  {
    name: 'Current Companies URLs for scrapping monitor',
    validator: (data: unknown) =>
      validateArray(
        (data as CollectedDataItem[]).find((item) => item.name === 'Current Companies URLs for scrapping monitor')
          ?.content
      ),
  },
];

export const linkedinSearchValidators = [
  {
    name: 'Search names',
    validator: (data: unknown) => validateArray(data as Partial<Contact>[]),
  },
  {
    name: 'Search locations',
    validator: (data: unknown) =>
      validateArray(data as Partial<Contact>[]) &&
      (data as Partial<Contact>[]).some(({ country }) => validateString(country)),
  },
];

export const calendarValidators = [
  {
    name: 'Search meeting title',
    validator: (data: unknown) =>
      validateString(
        (data as CollectedDataItem[]).find((item) => item.name.startsWith('Search meeting title'))?.content
      ),
  },
  {
    name: 'Search meeting time',
    validator: (data: unknown) =>
      validateString(
        (data as CollectedDataItem[]).find((item) => item.name.startsWith('Search meeting time'))?.content
      ),
  },
];

export const googleCalendarValidators = [
  ...calendarValidators,
  {
    name: 'Search meeting emails',
    validator: (data: unknown) =>
      validateArray(
        (data as CollectedDataItem[]).find((item) => item.name.startsWith('Search meeting emails'))?.content
      ),
  },
];

export const gmailValidators = [
  {
    name: 'Sender and recipients emails',
    validator: (data: unknown) =>
      validateArray((data as CollectedEmail)?.senderDomains) ||
      validateArray((data as CollectedEmail)?.recipientsDomains),
  },
  {
    name: 'Email subject',
    validator: (data: unknown) => validateString((data as CollectedEmail)?.subject),
  },
];

export const crmContactValidators = [
  {
    name: 'Full Name',
    validator: (data: unknown) => validateString((data as Partial<Contact>)?.name),
  },
  {
    name: 'Company Website',
    validator: (data: unknown) => validateString((data as Partial<Contact>)?.site),
  },
];

export const crmAccountValidators = [
  {
    name: 'Company Website',
    validator: (data: unknown) => validateString(data),
  },
];
